<template>
  <div class="order-wrap">
    <div class="goods-wrap">
      <van-image class="img" :src="itemInfo.image_url" fit="contain" />
      <div class="goods-info">
        <div class="goods-name">{{ order.desc || order.name }}</div>
        <div class="goods-price">
          会员优惠价：<span>￥{{ order.amount }}</span
          ><span class="goods-value">原价￥{{ order.face_value }}</span>
        </div>
      </div>
    </div>
    <div class="order-info">
      <div class="order-item">
        <div class="label">订单编号</div>
        <div class="value">
          {{ order.order_number }}
          <span
            round
            size="mini"
            class="copy"
            v-throttle
            v-clipboard:copy="order.order_number"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
            v-ans="{
              event_id: 'order_detail_click_copyorder',
              order_id: order.order_number,
              namespace,
            }"
            >复制</span
          >
        </div>
      </div>
      <div class="order-item">
        <div class="label">
          {{ type === "aftermarket" ? "申请时间" : "下单时间" }}
        </div>
        <div class="value">
          {{ type === "aftermarket" ? refundTime : orderTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import dayjs from "dayjs";
import Vue from "vue";

import { useStore } from "@/components/use/base";

const vm = Vue.prototype;

export default defineComponent({
  props: ["order", "images", "type", "afterMarketInfo", "itemInfo"],
  setup(props) {
    const store = useStore();

    const namespace = computed(() => store.state.namespace);

    const orderTime = computed(() => {
      return dayjs(props.order.t_created).format("YYYY-MM-DD HH:mm:ss");
    });

    const refundTime = computed(() => {
      return dayjs(props.afterMarketInfo.t_refund).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    });

    const copySuccess = () => {
      vm.$toast("复制成功");
    };
    const copyError = () => {
      vm.$toast("复制失败,请手动复制");
    };

    return {
      orderTime,
      namespace,
      refundTime,
      copySuccess,
      copyError,
    };
  },
});
</script>

<style lang="less" scoped>
.order-wrap {
  background: #ffffff;
  border-radius: 8px;
  padding: 12px 12px 22px 12px;
  margin-top: 12px;
}

.goods-wrap {
  display: flex;
  padding-bottom: 8px;
  border-bottom: 1px solid #dcdada;

  .img {
    width: 55px;
    height: 55px;
    background: #f1f1f1;
    border-radius: 8px;
  }

  .goods-info {
    margin-left: 12px;

    .goods-name {
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }

    .goods-price {
      margin-top: 3px;
      font-weight: 400;
      font-size: 11px;
      color: #333333;
      line-height: 16px;

      .goods-value {
        margin-left: 10px;
        text-decoration-line: line-through;
        color: #999999;
        font-weight: 400;
      }
    }

    .goods-count {
      margin-top: 4px;
      font-weight: 400;
      font-size: 10px;
      color: #999999;
      line-height: 14px;
    }
  }
}

.order-info {
  margin-top: 11px;

  .order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 7px;

    .label {
      font-weight: 400;
      font-size: 11px;
      color: #999999;
      line-height: 21px;
    }

    .value {
      font-weight: 500;
      font-size: 11px;
      color: #000000;
      line-height: 21px;
    }
  }
}
</style>